const LOGIN_REMEMBER_KEY = 'xKlPeEEJkcr_login_remember';
let loginMode = 'username';
let loginPending2faToken = null;

$(document).ready(function() {
    restoreRememberedLogin();

    $('#loginModeUsername').on('click', function(e) {
        e.preventDefault();
        setLoginMode('username');
    });

    $('#loginModeEmail').on('click', function(e) {
        e.preventDefault();
        setLoginMode('email');
    });

    $('#login2faBackBtn').on('click', function(e) {
        e.preventDefault();
        loginPending2faToken = null;
        $('#loginStepCredentials').removeClass('d-none');
        $('#loginStep2fa').addClass('d-none');
        $('.login-2fa-input').val('');
    });

    $('#logInBtn').on('click', function(e) {
        e.preventDefault();

        const button = $(this);
        const identifier = getLoginIdentifier();
        const password = $('#passwordTb').val().trim();

        if (!isLoginIdentifierValid(identifier)) {
            return;
        }

        if (!password || password.length < 6) {
            notify('error', 'Please enter a valid password');
            return;
        }

        const turnstileToken = getVisibleTurnstileToken();
        if ($('#loginStepCredentials .login-turnstile [data-sitekey]').length && !turnstileToken) {
            notify('error', 'Please complete the verification challenge');
            return;
        }

        btnLoader.start(button, 'Logging In...');

        const payload = { username: identifier, password };
        if (turnstileToken) {
            payload.turnstile_token = turnstileToken;
        }
        payload.redirect = getRedirect();

        $.ajax({
            url: '/api/auth/login',
            method: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify(payload),
            success: function(res) {
                btnLoader.stop(button);

                if (res.success && res.requires_2fa && res.pending_token) {
                    loginPending2faToken = res.pending_token;
                    $('#loginStepCredentials').addClass('d-none');
                    $('#loginStep2fa').removeClass('d-none');
                    $('.login-2fa-input').val('').first().focus();
                    notify('info', 'Enter your authentication code');
                    return;
                }

                if (res.success) {
                    saveRememberedLogin(identifier);
                    notify('success', 'Login successful. Redirecting…');

                    let target = (res.redirect && res.redirect.startsWith('/')) ? res.redirect : '/account';
                    if (res.requires_email_verification) {
                        target = '/verify-email';
                    } else if (res.requires_phone_verification) {
                        target = '/verify-phone';
                    }

                    setTimeout(() => {
                        window.location.href = target;
                    }, 800);
                } else {
                    resetTurnstile();
                    notify('error', res.error || 'Login failed. Please try again.');
                }
            },
            error: function(err) {
                btnLoader.stop(button);
                resetTurnstile();
                const msg = err.responseJSON?.error || 'An error occurred during login. Please try again later.';
                notify('error', msg);
            }
        });
    });

    if (typeof OTPHelper !== 'undefined') {
        OTPHelper.initOtpFields('.login-2fa-input');
    }

    $('#verify2faLoginBtn').on('click', function(e) {
        e.preventDefault();

        let code = '';
        $('.login-2fa-input').each(function() {
            code += $(this).val();
        });

        if (code.length !== 6) {
            notify('error', 'Please enter all 6 digits');
            return;
        }

        if (!loginPending2faToken) {
            notify('error', 'Session expired. Please log in again.');
            $('#loginStep2fa').addClass('d-none');
            $('#loginStepCredentials').removeClass('d-none');
            return;
        }

        const button = $(this);
        btnLoader.start(button, 'Verifying...');

        $.ajax({
            url: '/api/auth/verify2faLogin',
            method: 'POST',
            contentType: 'application/json',
            dataType: 'json',
            data: JSON.stringify({
                pending_token: loginPending2faToken,
                totp_code: code,
                redirect: getRedirect()
            }),
            success: function(res) {
                btnLoader.stop(button);

                if (res.success) {
                    notify('success', 'Login successful. Redirecting…');
                    const target = (res.redirect && res.redirect.startsWith('/')) ? res.redirect : '/account';
                    setTimeout(() => {
                        window.location.href = target;
                    }, 800);
                } else {
                    notify('error', res.message || 'Invalid authentication code');
                }
            },
            error: function(err) {
                btnLoader.stop(button);
                const msg = err.responseJSON?.message || err.responseJSON?.error || 'Verification failed. Please try again.';
                notify('error', msg);
            }
        });
    });

    checkLoginQueryMessages();
});


function setLoginMode(mode) {
    loginMode = mode === 'email' ? 'email' : 'username';
    loginPending2faToken = null;

    const isEmail = loginMode === 'email';

    $('#loginModeUsername').toggleClass('active', !isEmail).attr('aria-selected', !isEmail ? 'true' : 'false');
    $('#loginModeEmail').toggleClass('active', isEmail).attr('aria-selected', isEmail ? 'true' : 'false');
    $('#loginIdentifierUsername').toggleClass('d-none', isEmail);
    $('#loginIdentifierEmail').toggleClass('d-none', !isEmail);
    $('#loginStepCredentials').removeClass('d-none');
    $('#loginStep2fa').addClass('d-none');
    $('.login-2fa-input').val('');

    if (isEmail) {
        $('#emailTb').trigger('focus');
    } else {
        $('#usernameTb').trigger('focus');
    }
}


function getLoginIdentifier() {
    if (loginMode === 'email') {
        return $('#emailTb').val().trim().toLowerCase();
    }

    return $('#usernameTb').val().trim();
}


function isLoginIdentifierValid(identifier) {
    if (loginMode === 'email') {
        if (!identifier || !isValidEmailAddress(identifier)) {
            notify('error', 'Please enter a valid email address');
            return false;
        }
        return true;
    }

    if (!identifier || identifier.length < 3) {
        notify('error', 'Please enter a valid username');
        return false;
    }

    return true;
}


function isValidEmailAddress(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}


function restoreRememberedLogin() {
    try {
        const saved = JSON.parse(localStorage.getItem(LOGIN_REMEMBER_KEY) || 'null');
        if (!saved || !saved.value) {
            return;
        }

        if (saved.type === 'email') {
            setLoginMode('email');
            $('#emailTb').val(saved.value);
        } else {
            setLoginMode('username');
            $('#usernameTb').val(saved.value);
        }

        $('#remember').prop('checked', true);
    } catch (e) {}
}


function saveRememberedLogin(identifier) {
    if ($('#remember').is(':checked')) {
        localStorage.setItem(LOGIN_REMEMBER_KEY, JSON.stringify({
            type: loginMode,
            value: identifier
        }));
        return;
    }

    localStorage.removeItem(LOGIN_REMEMBER_KEY);
}


function getVisibleTurnstileToken() {
    const visibleStep = $('.login-step:not(.d-none)');
    const token = visibleStep.find('[name="cf-turnstile-response"]').val();
    return token ? token.trim() : '';
}


function getRedirect() {
    const redirectFromInput = ($('input[name="redirect"]').val() || '').trim();
    const redirectFromUrl = (new URLSearchParams(window.location.search)).get('redirect') || '';
    const redirect = (redirectFromUrl || redirectFromInput).trim();
    return (redirect && redirect.startsWith('/') && redirect.indexOf('//') === -1) ? redirect : '/account';
}


function resetTurnstile() {
    try {
        if (typeof turnstile !== 'undefined' && typeof turnstile.reset === 'function') {
            turnstile.reset();
        }
    } catch (e) {}
}


function checkLoginQueryMessages() {
    const params = new URLSearchParams(window.location.search);

    if (params.has('success')) {
        const code = params.get('success');

        switch (parseInt(code)) {
            case 1:
                notify('success', 'You have been logged out successfully.');
            break;
        }
    }
}
